import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, Enums, inject, Modal, ModalHandle, TasksStore, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { BsPencilSquare } from '@react-icons/all-files/bs/BsPencilSquare';
import { BsTrash } from '@react-icons/all-files/bs/BsTrash';
import { Button, ButtonGroup } from 'reactstrap';
import { AccountsStore } from '../Accounts/AccountsStore';
import { CreateOrEditProductionProject } from './CreateOrEditProductionProject';
//import { FileSystemsStore } from './FileSystemsStore';
import { ProductionProjectsStore } from './ProductionProjectsStore';

export interface IProductionProjectItemProps {
    readonly productionProject: Mri.ProductionProjects.ProductionProject;
    readonly history: any;
}

@autoinject
@observer
export class ProductionProjectItem extends React.Component<IProductionProjectItemProps> {
    public render() {
        const productionProject = this.props.productionProject;

        return (
            <tr className={!productionProject.projectStatus ? 'inactive-row' : ''}>
                <td className="align-middle">{productionProject.name}</td>

                <td className="align-middle">{this.account?.accountName}</td>

                <td className="align-middle">{Enums.toString(Enums.ProjectStatus, productionProject.projectStatus)}</td>

                <td className="align-middle">
                    <ButtonGroup className="py-1">
                        <Tooltip message="Edit Project" delay={0}>
                            <Button color="primary" onClick={this.modalHandle.open}>
                                <BsPencilSquare />
                            </Button>
                        </Tooltip>

                        {productionProject.projectStatus == Mri.ProductionProjects.ProjectStatus.ToBeDeleted && (
                            <Tooltip message="Delete" delay={0}>
                                <Button color="danger" className="dt-border" onClick={this.deleteAsync}>
                                    <BsTrash />
                                </Button>
                            </Tooltip>
                        )}
                    </ButtonGroup>
                </td>

                <CreateOrEditProductionProject
                    guid={productionProject.productionProjectGuid}
                    modalHandle={this.modalHandle}
                    viewState="edit"
                    history={this.props.history}
                />

                <Modal
                    className="modal-sm"
                    title="Confirm Deletion"
                    modalHandle={this.confirmModalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="text-center">{`Delete ${this.props.productionProject.name}?`}</div>
                </Modal>
            </tr>
        );
    }

    @bind
    @action
    private async deleteAsync() {
        if (await this.confirmModalHandle.confirm()) {
            const task = this.tasksStore.startSessionTask(`Delete ${this.props.productionProject.name}`);

            try {
                await this.productionProjectsStore.deleteAsync(this.props.productionProject.productionProjectGuid);
                task.complete();
            } catch (e: any) {
                task.error(e);
            }
        }
    }

    @computed
    private get account() {
        return this.accountsStore.accounts.get(this.props.productionProject.accountNumber);
    }

    private confirmModalHandle = new ModalHandle();
    private modalHandle = new ModalHandle();
    @inject
    private readonly accountsStore!: AccountsStore;
    @inject
    private readonly productionProjectsStore!: ProductionProjectsStore;
    @inject
    private readonly tasksStore!: TasksStore;
}
